import type { FC } from "react";
import { Link } from "@tanstack/react-router";
import type { ArticleMeta } from "../../lib/articles";

export const formatArticleDate = (iso: string) =>
  new Date(iso).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

interface ArticleCardProps {
  article: ArticleMeta;
}

const ArticleCard: FC<ArticleCardProps> = ({ article }) => (
  <Link
    to="/articles/$slug"
    params={{ slug: article.slug }}
    data-reveal
    className="group flex h-full flex-col rounded-2xl border border-white/5 bg-[#111111] p-6 transition-colors hover:border-cyan-400/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400"
  >
    <span className="mb-4 inline-block self-start rounded-full bg-cyan-400/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-cyan-300">
      {article.category}
    </span>
    <h3 className="mb-2 text-xl font-bold text-white transition-colors group-hover:text-cyan-300">
      {article.title}
    </h3>
    <p className="mb-4 flex-1 text-gray-400">{article.summary}</p>
    <div className="mb-3 flex flex-wrap items-center gap-x-3 text-sm text-gray-400">
      <time dateTime={article.publishedAt}>
        {formatArticleDate(article.publishedAt)}
      </time>
      <span aria-hidden="true">·</span>
      <span>{article.readingMinutes} min read</span>
    </div>
    <ul className="flex flex-wrap gap-2" aria-label="Tags">
      {article.tags.map((tag) => (
        <li
          key={tag}
          className="rounded bg-slate-800 px-2 py-0.5 font-mono text-xs text-slate-300"
        >
          {tag}
        </li>
      ))}
    </ul>
  </Link>
);

export default ArticleCard;
